import { render, staticRenderFns } from "./CorporateSSOLogin.vue?vue&type=template&id=5404e4e0&scoped=true"
import script from "./CorporateSSOLogin.vue?vue&type=script&lang=js"
export * from "./CorporateSSOLogin.vue?vue&type=script&lang=js"
import style0 from "./CorporateSSOLogin.vue?vue&type=style&index=0&id=5404e4e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5404e4e0",
  null
  
)

export default component.exports